module.exports = __webpack_public_path__ + "static/colgadas-009.thumb-431035c4c088a9fe7125f419e814326a.jpg";